import { createSelector } from 'reselect'

import confirmTypes from 'helpers/enums/confirmTypes'
import { localize } from 'helpers/translator'
import studentSlideTimerSelector from 'redux/selectors/student/timer'

import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'
import { sessionTypesWithNoSubmit, sessionTypesWithSubmitDisabled } from 'helpers/session/submitOptions'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.STUDENT_RECORDING_AUDIO_OEQ,
	featureFlagsTypes.OEQ_AUDIO_RESPONSES,
	featureFlagsTypes.RICH_TEXT_STUDENT_SESSION,
])

const getStudentViewData = state => state.student
const getConfirmsData = state => state.confirm
const getSlideId = (state, props) => props.session.session_uid + '_' + props.slide.slideId

const getConfirmType = function(confirms) {
	const confirmsArray = [
		confirmTypes.STUDENT_SUBMIT_OEQ_EMPTY_ANSWER_CONFIRM,
		confirmTypes.STUDENT_SUBMIT_OEQ_EMPTY_ANSWER_REQUIRED,
		confirmTypes.STUDENT_SUBMIT_OEQ_CONFIRMED,
		confirmTypes.STUDENT_DELETE_AUDIO_OEQ_CONFIRM,
		confirmTypes.STUDENT_SUBMIT_FAILED_CONFIRM,
		confirmTypes.STUDENT_REQUEST_MIC_PERMISSION,
	]

	if (confirms && confirms.length && confirmsArray.includes(confirms[0].confirmType)) {
		return confirms[0].confirmType
	} else {
		return null
	}
}

const getConfirmTexts = function(confirmType) {
	if (confirmType === confirmTypes.STUDENT_DELETE_AUDIO_OEQ_CONFIRM) {
		return {
			mainText: localize('oeq_delete_audio_confirm_text'),
			actionOneText: localize('global_cancel'),
			actionTwoText: localize('global_delete'),
		}
	} else if (confirmType === confirmTypes.STUDENT_SUBMIT_OEQ_EMPTY_ANSWER_CONFIRM) {
		return {
			mainText: localize('oeq_submit_empty_answer_confirm_text'),
			actionOneText: localize('oeq_submit_empty_answer_actionone_text'),
			actionTwoText: localize('oeq_submit_empty_answer_actiontwo_text'),
		}
	} else if (confirmType === confirmTypes.STUDENT_SUBMIT_OEQ_EMPTY_ANSWER_REQUIRED) {
		return {
			mainText: localize('oeq_submit_required_text'),
			actionTwoText: localize('action_button_gotit_cancel'),
		}
	} else {
		return null
	}
}

const getConfirm = function(confirms) {
	const confirmType = getConfirmType(confirms)
	if (confirmType) {
		return {
			type: confirmType,
			...getConfirmTexts(confirmType),
		}
	} else {
		return null
	}
}

const getStudentSlideData = createSelector(
	[
		getStudentViewData,
		getConfirmsData,
		studentSlideTimerSelector,
		getSlideId,
		featureFlagsSelector,
	],
	(student, confirms, timer, slideId, featureFlags) => {
		const slide_data = student.slides[slideId]
		const wereMicPermissionsRequired = student.wereMicPermissionsRequired

		let answer
		let studentRecordingAudioEnabled
		let isImmersiveReaderEnabled = false

		if (slide_data) {
			if (slide_data.answers) {
				answer = slide_data.answers[0] ? slide_data.answers[0].text : ''
			}
			studentRecordingAudioEnabled = slide_data.studentRecordingAudioEnabled
			isImmersiveReaderEnabled = slide_data.shouldShowImmersiveReader
		}

		return {
			slide_data,
			confirm: getConfirm(confirms),
			timer,
			answer,
			wereMicPermissionsRequired,
			shouldShowAudioRecorder: !!(
				featureFlags[featureFlagsTypes.STUDENT_RECORDING_AUDIO_OEQ]
				&& studentRecordingAudioEnabled
			),
			shouldShowImmersiveReader: isImmersiveReaderEnabled,
			canSubmitAudioResponses: featureFlags[featureFlagsTypes.OEQ_AUDIO_RESPONSES],
			isSubmitHidden: sessionTypesWithNoSubmit.includes(student.sessionType),
			isSubmitDisabled: sessionTypesWithSubmitDisabled.includes(student.sessionType),
			shouldShowHTMLComponent: featureFlags[featureFlagsTypes.RICH_TEXT_STUDENT_SESSION],
		}
	}
)

export default getStudentSlideData
